import { create } from 'zustand';

interface IPermissionStore {
  permissions: string[];
  isFreeUser: boolean;
  setPermissions: (newPermissions: string[]) => void;
  setIsFreeUser: (newIsFreeUser: boolean) => void;
}

const useAccessControlStore = create<IPermissionStore>((set) => ({
  permissions: [],
  isFreeUser: false,
  setPermissions: (newPermissions) => set({ permissions: newPermissions }),
  setIsFreeUser: (newIsFreeUser) => set({ isFreeUser: newIsFreeUser }),
}));

const hasPermission = (modulesAllowed: string[]): boolean => {
  const { permissions } = useAccessControlStore();

  return (modulesAllowed || []).every((slug) => (permissions || []).includes(slug));
};

export { useAccessControlStore, hasPermission };
